/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetCustomerProfileRequest} from '@cash-web/protos/squareup/cash/cashdotapp/api.pb'
import {GetCustomerProfileResponse} from '@cash-web/protos/squareup/cash/cashdotapp/api.pb'


export const getCustomerProfile = (request: GetCustomerProfileRequest, options?: CashRequestOptions) => post<GetCustomerProfileRequest, GetCustomerProfileResponse>("/2.0/cash/get-customer-profile", request, {...options, rejectOnError: true })